// WHY: mirrored from `_tableTokens.scss`; table.constants.test.ts pins them.
export const EDGE_PAD = 16;
export const CELL_PAD_X = 12;
export const CHECKBOX_SIZE = 20;
export const CHECKBOX_LEAD_IN = 4;
export const CHECKBOX_GUTTER_WIDTH = EDGE_PAD + CHECKBOX_SIZE + CHECKBOX_LEAD_IN;
// WHY: parked until custom columns ship (ANCR-6099).
export const COLUMN_HEADER_CHROME_ENABLED = false;
export const ACTIONS_COLUMN_WIDTH = 48;
// WHY: the trailing gutter holds what the last cell's padding is short of the edge.
export const END_EDGE_GUTTER_WIDTH = EDGE_PAD - CELL_PAD_X;
export const TABLE_FRAME_WIDTH = 2;
export const STRETCH_SAFETY_MARGIN = 1;
// WHY: a static table pads (edge − cell padding) on each side.
export const STATIC_EDGE_PADDING = 2 * (EDGE_PAD - CELL_PAD_X);
export const ROW_HEIGHT = 52;
export const COMPACT_ROW_HEIGHT = 40;
export const MIN_COLUMN_WIDTH = 100;
// WHY: past this width the label truncates with a tooltip instead of widening the column.
export const HEADER_FLOOR_CAP = 160;
// WHY: the widest strings each format produces in Lufga.
export const DATE_SAMPLES = {
    date: 'May 30, 2026',
    dateTime: 'May 30, 2026 12:00 PM',
    timeAgo: '10 months ago'
};
export const DEFAULT_COLUMN_WIDTH = 100;
export const MAX_COLUMN_WIDTH = 560;
export const MIN_SCROLLABLE_REMAINDER = 160;
export const DEFAULT_EMPTY_TEXT = '—';
export const SKELETON_ROW_COUNT = 5;
export const SKELETON_ROW_GAP = 8;
export const SKELETON_ROW_STAGGER_MS = 120;
export const MENU_ICON_SIZE = 16;
export const SPINNER_SIZE = 16;
export const INDICATOR_SIZE = 16;
export const SORT_GLYPH_WIDTH = 8;
export const SORT_GLYPH_HEIGHT = 12;
export const HEADER_LABEL_GAP = 8;
export const PRIMARY_ACTION_ICON_SIZE = 18;
export const KEBAB_ICON_SIZE = 20;
export const SETTINGS_ICON_SIZE = 20;
export const CHECK_CELL_ICON_SIZE = 16;
